import DarkButton from "components/actions/DarkButton";
import GrayButton from "components/actions/GrayButton";
import Dialog from "components/dialog";

const ConfirmationDialog = ({ isOpen, onClose, onConfirm, message }) => {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} placement="top">
      <div className="text-2xl font-bold dark:text-white mt-4 text-center">
        Are you sure?
      </div>

      <p className="text-sm text-gray-700 mt-2 text-center">{message}</p>

      <div className="flex flex-row justify-center gap-4 mt-6 mb-3">
        <DarkButton kind="danger" onClick={onConfirm}>
          Confirm
        </DarkButton>
        <GrayButton onClick={onClose}>Cancel</GrayButton>
      </div>
    </Dialog>
  );
};

export default ConfirmationDialog;
